import React from 'react';
import { Link } from 'react-router-dom';
import { FileSignature } from 'lucide-react';
import { hasLetterheadGap, letterheadGapFields } from '../../services/generationGate';

/**
 * Actionable notice shown when document generation (demand / sworn PoL) is blocked
 * because the attorney's OWN letterhead is incomplete — name / email / bar number.
 * Deep-links to /attorney/letterhead so the attorney lands directly on the fix,
 * instead of reading a raw "[BAR NUMBER]" placeholder error and having to hunt for
 * where to set it. Renders nothing unless a letterhead field is actually the blocker.
 */
export default function LetterheadGateNotice({
  blockingPlaceholders,
}: {
  blockingPlaceholders: string[];
}) {
  if (!hasLetterheadGap(blockingPlaceholders)) return null;
  const fields = letterheadGapFields(blockingPlaceholders);

  return (
    <div
      className="cs-body mt-3 flex items-start gap-3 rounded-lg p-3"
      style={{ borderLeft: '3px solid var(--color-brand)', color: 'var(--color-text-secondary)' }}
      data-testid="letterhead-gate-notice"
    >
      <FileSignature
        className="mt-0.5 h-4 w-4 flex-shrink-0"
        style={{ color: 'var(--color-needs-human-text)' }}
      />
      <div className="min-w-0">
        <p className="text-sm">
          Your letterhead is missing {fields.join(', ')} — the identity that prints on
          this document. Add it once and every demand letter and Proof of Loss picks it up.
        </p>
        <Link
          to="/attorney/letterhead"
          className="mt-1.5 inline-flex items-center gap-1 text-sm font-medium"
          style={{ color: 'var(--color-needs-human-text)' }}
        >
          Set up My Letterhead →
        </Link>
      </div>
    </div>
  );
}
